var render = function render(){var _vm=this,_c=_vm._self._c;return _c('split',{staticStyle:{"height":"500px","background-color":"#CCCCCC"}},[_c('split-area',{attrs:{"size":25}},[_vm._v("panel Left")]),_c('split-area',{attrs:{"size":75}},[_vm._v("panel right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }